import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const SPORTSMEN_REQUEST = 'FETCH_SPORTSMEN_REQUEST';
export const SPORTSMEN_FAILURE = 'FETCH_SPORTSMEN_FAILURE';
export const SPORTSMEN_SUCCESS = 'FETCH_SPORTSMEN_SUCCESS';

export const fetchSportsmen = () => {
    return function(dispatch) {
        dispatch(fetchSportsmenRequest());
        return axios(apiRequestOptions(apiPath.SPORTSMEN.LIST))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchSportsmenSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchSportsmenFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchSportsmenRequest = () => ({type: SPORTSMEN_REQUEST});

const fetchSportsmenFailure = error => ({
    type: SPORTSMEN_FAILURE,
    error,
});

const fetchSportsmenSuccess = data => ({
    type: SPORTSMEN_SUCCESS,
    data,
});